import log from '~/utils/log';

export default defineNuxtRouteMiddleware((to) => {
    const { $subSectionRegistry } = useNuxtApp();

    if (!isValidAccountSectionPath($subSectionRegistry.value, to.path, useCountryLanguages())) {
        log.debug(`[validate-account-section] Aborting navigation for invalid path: ${to.path}`);
        return abortNavigation(createError({ statusCode: 404, statusMessage: 'Account section not found' }));
    }
});
